import { CardActionArea } from '@mui/material';
import React from 'react'

const Down = () => {
    return ( <div style={{paddingTop: 150}}>
         <h1 className='colorbase text-center mb-4'>ดาวน์โหลดได้แล้ววันนี้!</h1>
         <div className='container'>
            <div className='row mt-2'>
                <div className='col-md-7'>
                    <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset20.webp' width='100%' />
                </div>
                <div className='col-md'>
                    <CardActionArea href='https://gpf-cdn.azureedge.net/images/statement/mygpf2565.html' target='_blank'>
                        <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset21.webp' className='mb-5 pt-5 pb-5' width='100%' />
                    </CardActionArea>
                    <CardActionArea href='https://cfl.gpf.or.th/Files/Viewer/?fileName=acd4afce-ba7f-482c-bdfe-646228af0736/Download_app_new.pdf' target='_blank'>
                        <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset22.webp' className='mt-5' width='100%' />
                    </CardActionArea>
                </div>
            </div>
         </div>
    </div> );
}
 
export default Down;